export const MIN_WIDGET_HEIGHT = 200;
export const PRIMARY_WIDGET_COLOR = '#5757b0';
export const LIGHT_PURPLE = '#f0f0ff';
